import { GameId } from 'src/app/model/game/game-id';
import { BlackjackUxGameController } from './blackjack-ux-game-controller';
import { UxGameController } from './ux-game-controller';
import { BlackjackUxGameListener } from '../listeners/blackjack-ux-game-listener';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { SolitaireUxGameListener } from '../listeners/solitaire-ux-game-listener';
import { SolitaireUxGameController } from './solitaire-ux-game-controller';
import { BlocksUxGameListener } from '../listeners/blocks-ux-game-listener';
import { BlocksUxGameController } from './blocks-ux-game-controller';
import { ActionBus, assertNever } from 'game-logic';
import { UxGameServiceAction } from 'src/app/core/services/ux-game/ux-game-service-action';

export class UxGameFactory {
  public static createGame(
    gameId: GameId,
    gameServiceActionBus: ActionBus<UxGameServiceAction>,
    gameServices: UxGameServices,
  ): UxGameController {
    switch (gameId) {
      case GameId.Blackjack: {
        const gameListener = new BlackjackUxGameListener(gameServices);
        return new BlackjackUxGameController(gameListener, gameServiceActionBus, gameServices);
      }
      case GameId.Blocks: {
        const gameListener = new BlocksUxGameListener(gameServices);
        return new BlocksUxGameController(gameListener, gameServiceActionBus, gameServices);
      }
      case GameId.Solitaire: {
        const gameListener = new SolitaireUxGameListener(gameServices);
        return new SolitaireUxGameController(gameListener, gameServiceActionBus, gameServices);
      }
      default:
        assertNever(gameId, 'No controller found for gameId');
    }
  }
}
